const modifierByFormat = {
  "FORMATO-A": 70,
  "FORMATO-B": 140,
  "FORMATO-C": 280,
};

export const calculateDailySpots = (formatoSelected, cantidadPantallas) =>
  cantidadPantallas * modifierByFormat[formatoSelected];
